import React, { Component } from 'react';

import * as util from '../util';
import * as globals from '../globals';

export default class BannerSection extends Component {
  render() {
    const { data } = this.props;
    const { address } = data;
    if (!address) return null;
    const { line1, city, region, postal } = address;
    if (!line1 || !city || !region || !postal) return null;
    return (
      <div
        className="section"
        style={{
          padding: '0px',
          height: '400px',
        }}
      >
        <iframe
          src={`https://www.google.com/maps/embed/v1/place?key=${
            globals.MAPS_API_KEY
          }&zoom=15&q=${encodeURIComponent(util.addrString(address))}`}
          frameBorder="0"
          allowFullScreen=""
          title={'Address map'}
          width={'100%'}
          height={'100%'}
        />
      </div>
    );
  }
}
